"use client";

import Link from "next/link";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import { DialogTitle } from "./ui/dialog";
import { Menu } from "lucide-react";
import { MobileMenuFooter } from "./mobile-menu-footer";
import { DRAWER_ROUTES } from "@/constants/drawer";
import { useCallback, useState } from "react";

export function MobileMenu() {
  const [selectedRoute, setSelectedRoute] = useState<string | null>(null);

  const handleRouteHover = useCallback(
    (routeName: string, isHovering: boolean) => {
      setSelectedRoute(isHovering ? routeName : null);
    },
    [],
  );

  return (
    <Sheet>
      <SheetTrigger
        aria-label="Otvori meni"
        className="cursor-pointer hover:opacity-75 p-2.5 focus:outline-none focus:ring-0"
      >
        <Menu className="size-6" />
      </SheetTrigger>
      <SheetContent
        className="p-7 sm:p-8 sm:px-10 size-full border-none shadow-none bg-linear-to-t from-background to-brand-50"
        selectedRoute={selectedRoute}
      >
        <div className="flex flex-col mt-8">
          {DRAWER_ROUTES.map((route, id) => (
            <SheetClose
              onMouseEnter={() => {
                handleRouteHover(route.label || "", true);
              }}
              onMouseLeave={() => {
                handleRouteHover(route.label || "", false);
              }}
              className="w-full hover:pl-6 py-4 transition-all duration-300 group ease-in-out"
              asChild
              key={id}
            >
              <Link href={route.href} className="flex items-start gap-1">
                <span className="uppercase tracking-[-0.04em] leading-[110%] text-3xl font-medium group-hover:text-brand-700 transition-all duration-150 ease-in-out">
                  {route.label}
                </span>

                <span className="text-brand-700 font-medium font-mono">
                  0{id + 1}
                </span>
              </Link>
            </SheetClose>
          ))}
        </div>

        <MobileMenuFooter />

        <DialogTitle></DialogTitle>
      </SheetContent>
    </Sheet>
  );
}
